import React from "react";
import { Auth } from "aws-amplify";
import { withRouter, Link } from "react-router-dom";
import _ from "lodash";
import qs from "query-string";
import { Form, Icon, Input, Button, message } from "antd";
const FormItem = Form.Item;

class ResetPasswordForm extends React.Component {
  state = {
    loading: false
  };

  componentDidMount() {
    const { location, form } = this.props;
    const query = qs.parse(location.search);
    const { username } = query;

    if (username) {
      form.setFieldsValue({ username: _.trim(username) });
    }
  }

  handleSubmit = e => {
    const { history, form } = this.props;
    e.preventDefault();
    this.setState({ loading: true });
    form.validateFields((err, values) => {
      if (!err) {
        const { username, code, newPassword } = values;
        Auth.forgotPasswordSubmit(username, code, newPassword)
          .then(() => {
            message.success("Contraseña actualizada correctamente!");
            history.push({ pathname: "/signin" });
          })
          .catch(err => {
            console.log(err);
            message.error(err.message);
            this.setState({ loading: false });
          });
      } else {
        console.log(err);
        this.setState({ loading: false });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <FormItem>
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "Ingresa tu usuario!" }]
          })(
            <Input
              prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Usuario"
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("code", {
            rules: [
              { required: true, message: "Ingresa el código de verificación!" }
            ]
          })(
            <Input
              prefix={
                <Icon type="mobile" style={{ color: "rgba(0,0,0,.25)" }} />
              }
              placeholder="Código de verificación"
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("newPassword", {
            rules: [{ required: true, message: "Ingresa tu nueva contraseña!" }]
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              type="password"
              placeholder="Nueva Contraseña"
            />
          )}
        </FormItem>
        <div className="footer-text-signup">
          <span>Recuerde que la contraseña debe contener</span>
          <ul>
            <li>Mínimo 8 caracteres</li>
            <li>Al menos una mayúscula y un número</li>
          </ul>
        </div>
        <FormItem>
          <Link className="login-form-forgot" to="/signin">
            Iniciar Sesión
          </Link>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={this.state.loading}
          >
            Enviar
          </Button>
          O <Link to="/forgot-password">Recuperar contraseña</Link>
        </FormItem>
      </Form>
    );
  }
}

export default withRouter(Form.create()(ResetPasswordForm));



// WEBPACK FOOTER //
// ./src/Components/ForgotPassword/ResetPasswordForm.js